import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import BrandLogoImageEditIcon from "../../pages/brandLogo/BrandLogoImageEditIcon";

const BrandLogoOneSingle = ({ data, sliderClassName, spaceBottomClass }) => {
  let src = data.link != undefined && data.link != "undefined" && data.link != "" ? data.link : "/";
  return (
    <div
      className={`antera-client-logo-container single-brand-logo ${sliderClassName ? sliderClassName : ""} ${spaceBottomClass ? spaceBottomClass : ""
        }`}
    >
      <div className="edit-inline">
        <BrandLogoImageEditIcon brandLogoId={data?._id} fromEditAction="topBottomSpace" />
      </div>
      {
        !!data.link ?
          <Link to={{ pathname: src }} target="_blank">
            <img style={{
                width: data.widthSize ? data.widthSize + "px" : "auto", maxWidth: "200px"
              }} 
              src={process.env.PUBLIC_URL + data.image} 
              alt=""
              className="antera-client-logo-image"
            />
          </Link> :
          <a style={{ cursor: "default" }}>
            <img style={{
                width: data.widthSize ? data.widthSize + "px" : "auto", maxWidth: "200px"
              }}
              src={process.env.PUBLIC_URL + data.image}
              alt=""
              className="antera-client-logo-image"
            />
          </a>
      }
    </div>
  );
};

BrandLogoOneSingle.propTypes = {
  data: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string
};

export default BrandLogoOneSingle;
